import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NgxPermissionsService, NgxPermissionsModule } from 'ngx-permissions';
import { ComponentsModule } from './components/components.module';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { MatProgressBarModule, } from '@angular/material/progress-bar';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { httpInterceptorProviders } from './core/interceptors';
import { LogoutCallbackComponent } from './logout-callback/logout-callback.component';

@NgModule({

  declarations: [
    AppComponent,
    PageNotFoundComponent,
    LogoutCallbackComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatCardModule,
    MatProgressBarModule,
    MatButtonModule,
    HttpClientModule,
    NgxPermissionsModule,
    ComponentsModule,
    BrowserAnimationsModule,
    MatIconModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    })
  ],
  providers: [httpInterceptorProviders],
  bootstrap: [AppComponent]
})

export class AppModule { }
